// initial state
const state = {
  countries: undefined,
  userActivities: undefined,
};

const actions = {
  setCountries: async (state, payload) => {
    state.dispatch("setCountries", payload);
  },
  setUserActivities: async (state, payload) => {
    state.dispatch("setUserActivities", payload);
  },
};

const mutations = {
  setCountries(state, countries) {
    state.countries = countries;
  },
  setUserActivities(state, activities) {
    state.userActivities = activities;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
